import { router } from "@inertiajs/react";
import { Container, Heading } from "@chakra-ui/react";
import Head from "@/components/Head";
import { RankingFilter, RankingList, type FilterType } from "@/components/Ranking";
import { Player } from "@/types";

interface Filters {
  gender?: string;
  prefecture?: string;
  age_group?: string;
}

interface Props {
  players: Player[];
  filters?: Filters;
}

const title = "現在のランキング";

export default function ({ players = [], filters = {} }: Props) {
  const handleFilterChange = (filterType: FilterType, value: string) => {
    const newFilters = {
      gender: filterType === "gender" ? value : filters.gender,
      prefecture: filterType === "prefecture" ? value : filters.prefecture,
      age_group: filterType === "age_group" ? value : filters.age_group,
    };

    // 空の値を除外
    const params = Object.fromEntries(
      Object.entries(newFilters).filter(([, v]) => v && v !== "")
    );

    router.get("/", params, { preserveScroll: true });
  };

  const handleReset = () => {
    router.get("/", {}, { preserveScroll: true });
  };

  return (
    <>
      <Head title={title} robots={true} />

      <Container maxW="6xl" p={6}>
        <div className="flex flex-col gap-6">
          <Container maxW="xl">
            <div className="flex flex-col gap-6">
              <Heading as="h1" size="lg">{title}</Heading>

              <RankingFilter
                filters={filters}
                onFilterChange={handleFilterChange}
                onReset={handleReset}
              />

              <RankingList players={players} />
            </div>
          </Container>
        </div>
      </Container>
    </>
  );
}
